import { queryCategoryTree } from "@/api/materiel";
import { onMounted, ref } from "vue";

export default function useCateGoryList() {
  const categoryList = ref([]);

  const getList = () => {
    queryCategoryTree().then((res) => {
      if (JSON.stringify(res.data) !== "{}") {
        categoryList.value = res.data;
      }
      
    });
  };

  onMounted(() => {
    getList();
  });
  return { categoryList };
}
